<div
  class="checkbox"
  [ngClass]="type === 'boxFirst' ? 'box-first' : 'label-first'"
>
  <label for="{{ id }}"><ng-content></ng-content></label>
  <ng-content select="input[type='checkbox']"></ng-content>
</div>
